import { derived, get, writable } from "svelte/store";
import { appManager } from "../../../../AppManager";
import { Guid } from "guid-typescript";
import "../../../../main";
export class ProfileRowManager {
    constructor(parent, settings) {
        this.routeStore = writable({
            type: "FeatureCollection",
            features: []
        });
        this.parent = parent;
        this.colorStore = writable(settings.color);
        this.colorStore.subscribe(color => {
            if (typeof this.map === "undefined")
                return;
            this.map.setPaintProperty(this.layerId, "line-color", color);
        });
        this.profileStore = writable(settings.profile);
        this.profileStore.subscribe(() => {
            this.routeStore.set({
                type: "FeatureCollection",
                features: []
            });
            this.tryCalculate();
        });
        this.visibleStore = writable(settings.visible);
        this.visibleStore.subscribe((v) => {
            if (typeof this.map === "undefined")
                return;
            if (v) {
                this.map.setLayoutProperty(this.layerId, "visibility", "visible");
                const data = get(this.routeStore);
                if (data.features.length === 0) {
                    this.tryCalculate();
                }
            }
            else {
                this.map.setLayoutProperty(this.layerId, "visibility", "none");
            }
        });
        this.widthStore = derived(this.profileStore, (profile) => {
            const type = profile.substring(0, profile.indexOf("."));
            switch (type) {
                case "bigtruck":
                    return 15;
                case "car":
                    return 10;
                case "bicycle":
                    return 7;
            }
            return 3;
        });
        this.widthStore.subscribe(width => {
            if (typeof this.map === "undefined")
                return;
            this.map.setPaintProperty(this.layerId, "line-width", width);
        });
        this.branchCommitId = get(this.parent.getBranchCommitIdStore());
        this.parent.getBranchCommitIdStore().subscribe((v) => {
            if (v === this.branchCommitId)
                return;
            this.routeStore.set({
                type: "FeatureCollection",
                features: []
            });
            this.branchCommitId = v;
            this.tryCalculate();
        });
        this.parent.getFromStore().subscribe(() => {
            this.routeStore.set({
                type: "FeatureCollection",
                features: []
            });
            this.tryCalculate();
        });
        this.parent.getToStore().subscribe(() => {
            this.routeStore.set({
                type: "FeatureCollection",
                features: []
            });
            this.tryCalculate();
        });
        this.routeStore.subscribe(routes => {
            if (typeof this.map === "undefined")
                return;
            if (routes.features.length == 0 && typeof this.sourceId === "undefined")
                return;
            this.addLayers();
            this.map.getSource(this.sourceId).setData(routes);
        });
    }
    async addToMap(map) {
        this.map = map;
    }
    addLayers() {
        if (typeof this.sourceId !== "undefined")
            return;
        const guid = Guid.create().toString();
        this.sourceId = `routes-${guid}`;
        this.layerId = `routes-${guid}`;
        this.map.addSource(this.sourceId, {
            "type": "geojson",
            "data": {
                "type": "FeatureCollection",
                "features": []
            }
        });
        this.map.addLayer({
            "id": this.layerId,
            "type": "line",
            "source": this.sourceId,
            "layout": {
                "line-cap": "round",
                "visibility": "visible"
            },
            "paint": {
                "line-color": get(this.colorStore),
                "line-opacity": 0.8,
                "line-width": get(this.widthStore)
            }
        }, "symbol");
    }
    getRouteStore() {
        return this.routeStore;
    }
    getVisibleStore() {
        return this.visibleStore;
    }
    getProfileStore() {
        return this.profileStore;
    }
    getColorStore() {
        return this.colorStore;
    }
    getProfiles() {
        return this.parent.getProfiles();
    }
    tryCalculate() {
        this.tryCalculateAsync().then().catch(reason => {
            console.error(`Route calculation ${get(this.profileStore)} failed or cancelled: ${reason}`);
        });
    }
    async tryCalculateAsync() {
        this.routeRequest?.abort();
        const data = {
            type: "FeatureCollection",
            features: []
        };
        // if not from/to do nothing.
        const from = get(this.parent.getFromStore());
        if (typeof from === "undefined") {
            this.routeStore.set(data);
            return;
        }
        const to = get(this.parent.getToStore());
        if (typeof to === "undefined") {
            this.routeStore.set(data);
            return;
        }
        if (typeof this.branchCommitId === "undefined") {
            this.routeStore.set(data);
            return;
        }
        if (!get(this.getVisibleStore())) {
            this.routeStore.set(data);
            return;
        }
        // start new request.
        this.routeRequest = new AbortController();
        const signal = this.routeRequest.signal;
        let profile = get(this.profileStore);
        let maxIncrease = 0;
        if (profile.endsWith("%")) {
            maxIncrease = Number(profile.substring(profile.lastIndexOf(".") + 1, profile.length - 1));
            profile = profile.substring(0, profile.lastIndexOf("."));
        }
        const result = await appManager.routingFacade.getRoutesAsFeatureCollection({
            locations: [from, to],
            profile: profile,
            branchCommitId: this.branchCommitId,
            maxIncrease: maxIncrease,
        }, signal);
        this.routeStore.set(result);
    }
}
